<template>
  <div class="game">
    <div class="btnbox">
      <el-button class="add-btn" @click="addGame" icon="el-icon-plus"
        >添加游戏</el-button
      >
    </div>
    <div class="top">
      <div class="querybox">
        <div>
          <p>游戏名称：</p>
          <el-input
            v-model="queryParams.webGameName"
            placeholder="请输入游戏名称"
            clearable
          ></el-input>
        </div>
      </div>
      <div class="handlebox">
        <div class="btnbox">
          <!-- <el-popconfirm
            icon="el-icon-info"
            icon-color="red"
            title="确认删除选中的游戏吗？"
            popper-class="customerdel-popover"
            @confirm="deleteFn()"
          >
            <el-button
              slot="reference"
              icon="el-icon-delete"
              class="add-btn"
              style="margin-right: 10px"
              >删除</el-button
            >
          </el-popconfirm> -->
          <el-button
            type="primary"
            icon="el-icon-refresh-right"
            class="reset-btn"
            @click="resetFn"
            >重置</el-button
          >
          <el-button
            type="primary"
            icon="el-icon-search"
            class="search-btn"
            @click="search"
            >查询</el-button
          >
        </div>
      </div>
    </div>
    <div class="content">
      <el-table
        :data="tableData"
        tooltip-effect="dark"
        :header-cell-style="{ 'text-align': 'center' }"
        :cell-style="{ 'text-align': 'center' }"
      >
        <!-- <el-table-column type="selection"> </el-table-column> -->
        <el-table-column prop="webGameCover" label="游戏封面">
          <template slot-scope="{ row }">
            <div class="logo">
              <img :src="row.webGameCover" alt="" />
            </div>
          </template>
        </el-table-column>
        <el-table-column prop="webGameName" label="游戏名称"></el-table-column>
        <el-table-column prop="webGameType_dictText" label="游戏类型">
          <template slot-scope="{ row }">
            <span
              :style="{ color: row.webGameType === 1 ? '#483D8B' : '#2F4F4F' }"
              >{{ row.webGameType_dictText }}</span
            >
          </template>
        </el-table-column>
        <el-table-column
          prop="screenOrientation_dictText"
          label="屏幕方向"
        ></el-table-column>
        <el-table-column
          prop="webGameUrl"
          label="跳转链接"
          show-overflow-tooltip
        ></el-table-column>
        <el-table-column prop="createdTime" label="发布时间" min-width="120">
        </el-table-column>
        <el-table-column prop="status_dictText" label="状态">
          <template slot-scope="{ row }">
            <el-button :class="row.status === 0 ? 'success-btn' : 'fail-btn'">{{
              row.status_dictText
            }}</el-button>
          </template>
        </el-table-column>
        <el-table-column label="操作" min-width="120">
          <template slot-scope="{ row }">
            <el-popconfirm
              title="是否启用该游戏？"
              popper-class="customerdel-popover"
              @confirm="editGameState(row.id, 0)"
              v-if="Number(row.status) === 1"
            >
              <el-button class="textOrange-btn" slot="reference"
                >启用</el-button
              >
            </el-popconfirm>
            <el-popconfirm
              title="是否禁用该游戏？"
              popper-class="customerdel-popover"
              @confirm="editGameState(row.id, 1)"
              v-if="Number(row.status) === 0"
            >
              <el-button class="textOrange-btn" slot="reference"
                >禁用</el-button
              >
            </el-popconfirm>
            <el-button class="textOrange-btn" @click="goEdit(row.id)"
              >编辑</el-button
            >
            <el-popconfirm
              title="是否删除该游戏？"
              popper-class="customerdel-popover"
              @confirm="deleteFn(row.id)"
            >
              <el-button class="textOrange-btn" slot="reference"
                >删除</el-button
              >
            </el-popconfirm>
          </template>
        </el-table-column>
      </el-table>
      <!-- 分页组件 -->
      <pagination
        v-show="total > queryParams.pageSize"
        :total="total"
        :page.sync="queryParams.pageNum"
        :limit.sync="queryParams.pageSize"
        @pagination="init"
      />
    </div>
  </div>
</template>

<script>
import { getWebGameList, editWebGameStatus, deleteWebGame } from "@/api/game";
export default {
  data() {
    return {
      queryParams: {
        pageNum: 1,
        pageSize: 10,
        webGameName: "",
        timeSort: false,
      },
      tableData: [],
      total: 0, //总数
      selectList: [],
    };
  },
  created() {
    this.init();
  },
  mounted() {},
  methods: {
    //获取游戏列表
    async init() {
      const res = await getWebGameList(this.queryParams);
      this.tableData = res.result.records;
      this.total = res.result.total;
    },
    // 查询
    search() {
      this.queryParams.pageNum = 1;
      this.init();
    },
    //重置
    resetFn() {
      this.queryParams.musicSinger = "";
      this.queryParams.musicName = "";
      this.queryParams.pageNum = 1;
      this.init();
    },
    // 游戏状态
    async editGameState(id, status) {
      const params = {
        status,
        id,
      };
      await editWebGameStatus(params);
      // this.$message.success("音乐删除成功");
      this.init();
    },
    // 新增游戏
    addGame() {
      this.$router.push({
        path: "/addGame",
        query: {
          type: "add",
        },
      });
    },
    // 编辑游戏
    goEdit(id) {
      this.$router.push({
        path: "/addGame",
        query: {
          type: "edit",
          id,
        },
      });
    },
    // 删除
    async deleteFn(id) {
      await deleteWebGame({ id });
      // // await deleteBanner(this.selectList);
      this.$message.success("删除成功");
      this.init();
      // console.log(111);
    },
  },
};
</script>
<style lang="scss" scoped>
.game {
  position: relative;
  > .btnbox {
    position: absolute;
    top: -88px;
    right: 0;
  }
  .top {
    display: flex;
    justify-content: space-between;
    padding-bottom: 16px;
    ::v-deep .querybox {
      display: flex;
      align-items: center;

      > div {
        display: flex;
        align-items: center;
        margin-right: 24px;
        > span {
          display: block;
          width: 15px;
          height: 1px;
          background: #979797;
          margin: 0 6px;
        }
        p {
          font-weight: 400;
          font-size: 14px;
          color: #262626;
          line-height: 20px;
          white-space: nowrap;
          // width: 100px;
        }
        .el-input,
        .el-range-editor {
          width: 200px;
        }
        input::-webkit-input-placeholder {
          /* WebKit browsers */
          color: rgba(0, 0, 0, 0.25);
        }
        .el-input__inner {
          background: #ffffff;
          border-radius: 4px;
          border: 1px solid #d9d9d9;
        }
      }
    }
    .handlebox {
      display: flex;
      align-items: center;
    }
  }
  .content {
    padding-top: 20px;
    .logo {
      display: flex;
      justify-content: center;
      img {
        width: 100px;
        // height: 50px;
        border-radius: 5px;
      }
    }
    .textOrange-btn {
      margin: 0 10px;
    }
  }
}
</style>
